import { date } from '../../../lib/helpers';
import { headers, search } from './attributes';


export default {
  data: () => ({
    updateMenu: false,
    updateFormatted: '',
    options: {},
    headers,
    search,
    selectedRow: '',
    filterData: [
      { label: 'Fee Name', field: 'fee_name', type: 'text' },
      { label: '', field: 'empty_1', type: '' },
      { label: 'Updated By', field: 'update_by_username', type: 'text' },
      { label: 'Old Fee Sharing', field: 'old_fee_sharing', type: 'text' },
      { label: 'New Fee Sharing', field: 'new_fee_sharing', type: 'text' },
      { label: 'Last Update', field: 'datetime', type: 'date' },
    ],
  }),

  computed: {
    tableData() {
      return this.allData.map((item, index) => ({
        ...item,
        number_index: index + 1,
        fee_name: item.data?.fee_name,
        sales_volume: item.data?.sales_volume,
        updated_by_username : item.data?.updated_by_username ,
        old_fee_sharing: item.data?.old_fee_sharing,
        new_fee_sharing: item.data?.new_fee_sharing,
        updated_at: item.data?.updated_at,
      }));
    },
    allData() {
      return this.$store.state.settingFee.logSpeFee.allData;
    },
    totalData() {
      return this.$store.state.settingFee.logSpeFee.totalData;
    },
    totalPage() {
      return this.$store.state.settingFee.logSpeFee.totalPage;
    },
    loading() {
      return this.$store.state.settingFee.logSpeFee.loading;
    },
    flashError: {
      get() {
        return this.$store.state.settingFee.logSpeFee.flashError;
      },
      set() {
        this.$store.commit('settingFee/logSpeFee/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.settingFee.logSpeFee.flashErrorMessage;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    'search.datetime': {
      handler() {
        this.updateFormatted = this.formatDate(this.search.datetime);
        this.getData();
      },
    },
  },

  methods: {
    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    getData() {
      this.$store.commit('settingFee/logSpeFee/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('settingFee/logSpeFee/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    clearSearch() {
      this.search.fee_name = '';
      this.search.update_by_username = '';
      this.search.old_fee_sharing = '';
      this.search.new_fee_sharing = '';
      this.search.datetime = '';
      this.$nextTick(() => {
        this.getData();
      });
    },
  },
};